// eslint-disable-next-line @typescript-eslint/no-var-requires
const preApprovalResponse = require('./pre-approval.json');

export default preApprovalResponse;
